import Bioheader from './Bioheader';
import Biofooter from './Biofooter';
import Biodatamain from './Biodatamain';
import { useEffect } from "react";
import "./Biodata.scss";
import { Helmet } from "react-helmet";

function Biodata() {
  useEffect(() => {
    document.body.classList.add("biodata_body");

    return () => {
      document.body.classList.remove("biodata_body"); 
    };
  }, []);
  return (
    <div className='container '>
      <Bioheader />
      <Helmet>
        <script type="application/ld+json">
          {`{
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is a marriage biodata maker?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A marriage biodata maker is a free online tool that helps you create a professional marriage biodata and download it in PDF or image format."
          }
        },
        {
          "@type": "Question",
          "name": "Is there any fee for creating a biodata?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No, this online marriage biodata maker is completely free to use with no hidden charges."
          }
        },
        {
          "@type": "Question",
          "name": "Do I need to create an account to make the biodata?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "No account is required. You can directly enter your details and create your marriage biodata online without signing up."
          }
        },
        {
          "@type": "Question",
          "name": "How many types of templates are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Multiple professionally designed marriage biodata templates are available, allowing users to choose a layout as per their preference."
          }
        },
        {
          "@type": "Question",
          "name": "How do I download the biodata?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "After completing your biodata, simply click the download button to save it as a PDF or image file."
          }
        },
        {
          "@type": "Question",
          "name": "Can the biodata be downloaded in formats other than PDF?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, apart from PDF, you can also download your marriage biodata in image (PNG) format."
          }
        },
        {
          "@type": "Question",
          "name": "Is my information secure on your website?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, your information is secure and is not stored or shared with any third party."
          }
        },
        {
          "@type": "Question",
          "name": "Can the biodata have multiple pages?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, if the information is extensive, the biodata can automatically generate multiple pages."
          }
        }
      ]
    }
    `}
        </script>
        <script type="application/ld+json">
          {`{
          "@context": "https://schema.org",
          "@type": "NewsMediaOrganization",
          "@id": "https://hindi.webdunia.com/#organization",
          "name": "Webdunia",
          "url": "https://hindi.webdunia.com,
          "logo": {
            "@type": "ImageObject",
            "url": "https://nonprod-media.webdunia.com/public_html/app-logo/hi-logo.png",
            "width": 241,
            "height": 126
          },
          "sameAs": [
              "https://www.facebook.com/pages/Webdunia-Hindi/169225143115629/",
              "https://x.com/WebduniaHindi/",
              "https://www.instagram.com/webduniahindi/",
              "https://www.youtube.com/user/webduniaindia/"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "60/2 Babulabh Chand Chajlani Marg Naidunia Parishar, Keshar Bagh Rd, Nai Duniya",
            "addressLocality": "Indore",
            "addressRegion": "Madhya Pradesh",
            "postalCode": "452009",
            "addressCountry": "IN"
          }
        }
    `}
        </script>
        <script type="application/ld+json">
          {`{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "@id":"https://hindi.webdunia.com/biodata-maker#webpage",
          "name": "biodata maker",
          "description": "Premium Marriage Biodata,Create Beautiful Biodata for Marriage, Perfect Marriage Biodata Maker , Online Biodata Maker For Marriage , Free Marriage Biodata Maker,Free Templates for Marriage Biodata, Latest Marriage Biodata Maker, Free Biodata Maker for Marriage, Best Biodata Maker, Bio Data Pdf Maker, biodata for marriage kaise banaye, marriage biodata maker free, bio data for marriage pdf, bio data for marriage pdf in hindi, बायोडाटा,  बायोडाटा फॉर्म, विवाह बायोडाटा, शादी बायोडाटा, मैरिज बायोडाटा , बायोडाटा फॉरमेट",
          "url": "https://hindi.webdunia.com/biodata-maker",
          "inLanguage": "hi",
          "mainContentOfPage": "News",
          "publisher": {
          "@type": "NewsMediaOrganization",
          "@id":"https://hindi.webdunia.com/#organization",
            "name": "Webdunia",
            "logo": {
              "@type": "ImageObject",
              "url": "https://nonprod-media.webdunia.com/public_html/include/_mod/site/common-images/wd-logo/logo-hi.png",
              "width": 180,
              "height": 94
            }
          }
        }
    `}
        </script>
        <script type="application/ld+json">
          {`{
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "name": "Biodata Maker",
        "description": "Premium Marriage Biodata,Create Beautiful Biodata for Marriage, Perfect Marriage Biodata Maker , Online Biodata Maker For Marriage , Free Marriage Biodata Maker,Free Templates for Marriage Biodata, Latest Marriage Biodata Maker, Free Biodata Maker for Marriage, Best Biodata Maker, Bio Data Pdf Maker, biodata for marriage kaise banaye, marriage biodata maker free, bio data for marriage pdf, bio data for marriage pdf in hindi, बायोडाटा,  बायोडाटा फॉर्म, विवाह बायोडाटा, शादी बायोडाटा, मैरिज बायोडाटा , बायोडाटा फॉरमेट",
        "applicationCategory": "UtilityApplication",
        "operatingSystem": "Web",
        "url": "https://hindi.webdunia.com/biodata-maker",
        "keywords": "Get the Free Templates for Marriage Biodata, Latest Marriage Biodata Maker, Free Biodata Maker for Marriage, Best Biodata Maker, Bio Data Pdf Maker,bio data for marriage pdf in hindi and much more, बायोडाटा,  बायोडाटा फॉर्म, विवाह बायोडाटा" ,
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "INR"
        }
      }
          `}
        </script>

      </Helmet>
      <Biodatamain />
      <Biofooter />
    </div>
  )
}

export default Biodata

